var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 391.161,
    height: 244.307,
    viewBox: "0 0 391.161 244.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(-615.839 -16)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u2122",
    transform: "translate(999 87)",
    fill: "#113657",
    fontSize: 16,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8,
    y: 0
  }, "\u2122")), /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199",
    transform: "translate(-32.58 318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M390.161,69.14h-85A122.2,122.2,0,0,0,85,69.14H0V175.167H85a122.2,122.2,0,0,0,220.161,0h85Z",
    transform: "translate(648.419 -302)",
    fill: "#214669"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M380.073,165.135H10.088V79.172H380.073Zm-367.485-2.5H377.573V81.672H12.588Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 364.985,
    height: 80.963,
    transform: "translate(661.007 -220.328)",
    fill: "#386c9b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    width: 27.447,
    height: 2,
    transform: "translate(777.323 -244.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    width: 36.428,
    height: 2,
    transform: "translate(768.217 -235.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    width: 27.447,
    height: 2,
    transform: "translate(882.229 -244.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_720",
    "data-name": "Rectangle 720",
    width: 36.428,
    height: 2,
    transform: "translate(882.354 -235.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    width: 87.625,
    height: 2,
    transform: "translate(798.234 -99.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_722",
    "data-name": "Rectangle 722",
    width: 50.819,
    height: 2,
    transform: "translate(818.225 -88.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M124.463,183.337v-.046A8.148,8.148,0,0,1,132.822,175a8.272,8.272,0,0,1,6.322,2.474l-2.244,2.589a5.916,5.916,0,0,0-4.1-1.81,4.749,4.749,0,0,0-4.649,4.993v.045a4.762,4.762,0,0,0,4.649,5.039,5.784,5.784,0,0,0,4.214-1.878l2.245,2.268a8.2,8.2,0,0,1-6.573,2.862,8.092,8.092,0,0,1-8.223-8.245",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M144.781,183.337v-.046a8.524,8.524,0,0,1,17.041-.045v.045a8.524,8.524,0,0,1-17.041.046m13.353,0v-.046a4.871,4.871,0,0,0-4.855-5.038,4.8,4.8,0,0,0-4.81,4.993v.045a4.871,4.871,0,0,0,4.855,5.039,4.8,4.8,0,0,0,4.81-4.993",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M168.1,175.276h3.8l4.215,6.779,4.213-6.779h3.8v16.032h-3.5V180.841l-4.511,6.848h-.092l-4.467-6.779v10.4H168.1Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M191.65,175.276h6.55c3.825,0,6.138,2.268,6.138,5.542v.046c0,3.711-2.886,5.635-6.481,5.635h-2.68v4.809H191.65Zm6.321,8.085c1.764,0,2.794-1.054,2.794-2.428v-.046c0-1.58-1.1-2.427-2.862-2.427h-2.726v4.9Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M215.954,175.161h3.252l6.871,16.147h-3.686l-1.467-3.6h-6.779l-1.465,3.6h-3.6Zm3.711,9.436-2.13-5.2-2.131,5.2Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M232.219,175.276h3.252l7.513,9.871v-9.871h3.481v16.032h-3L235.7,181.116v10.192h-3.481Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M258.493,184.987l-6.161-9.711h4.123l3.825,6.436,3.894-6.436h4.007l-6.161,9.643v6.389h-3.527Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M173.272,56.361h-4.879V53.109h13.284v3.252H176.8v12.78h-3.527Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M188.047,53.109h3.527v6.344h6.505V53.109h3.527V69.141h-3.527V62.706h-6.505v6.435h-3.527Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M209.122,53.109h12.093v3.138h-8.589V59.5h7.559v3.137h-7.559V66h8.7v3.137H209.122Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M156.76,40.781l-2.6,1.322,1.2,2.357,2.924-1.485.456,1.341-4.179,2.122-4.12-8.115,4.162-2.112.645,1.271-2.727,1.385,1,1.975,2.6-1.323Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M166.263,39.011a.908.908,0,0,0,1.177.665.685.685,0,0,0,.51-.949c-.158-.467-.453-.651-1.331-.678-1.749-.05-2.317-.467-2.638-1.424a1.989,1.989,0,0,1,1.5-2.616,2.041,2.041,0,0,1,2.844,1.332l-1.458.49c-.082-.233-.327-.887-1.033-.65a.609.609,0,0,0-.414.832c.141.418.445.53,1.333.558,1.569.045,2.277.4,2.636,1.467.436,1.3-.127,2.315-1.624,2.819a2.142,2.142,0,0,1-3-1.344Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M175.458,31.39l.9-.173-.33-1.709,1.578-.3.329,1.709,1.056-.2.249,1.3-1.055.2.721,3.744c.077.4.193.609.685.514a1.874,1.874,0,0,0,.384-.1l.223,1.16a2.762,2.762,0,0,1-.937.325c-1.094.211-1.644-.1-1.881-1.331l-.772-4-.9.173Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M196.41,36.327l0-.09c.086-1.5.777-2.528,2.189-3.97,1.077-1.111,1.331-1.425,1.375-2.313.033-.662-.086-1.133-.739-1.164-.682-.034-.885.516-.958,1.4l-1.547-.075c.081-1.389.741-2.693,2.615-2.6a2.17,2.17,0,0,1,2.269,2.578c-.051,1.046-.341,1.6-1.536,2.753a7.243,7.243,0,0,0-1.753,2.2l3.271.159-.279,1.364Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M214.626,34.041c-.66,3.342-1.645,4.389-3.44,4.033s-2.281-1.763-1.634-5.038c.695-3.517,1.925-4.157,3.435-3.859,1.594.315,2.311,1.466,1.639,4.864m-3.483-.751c-.429,2.172-.55,3.312.313,3.482s1.165-.887,1.6-3.077c.449-2.273.475-3.043-.351-3.207-.778-.153-1.135.662-1.559,2.8",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M220.913,40.44l.03-.085c.519-1.415,1.479-2.194,3.25-3.164,1.354-.751,1.689-.978,1.989-1.815.223-.624.248-1.11-.37-1.33-.642-.23-1,.237-1.323,1.061l-1.459-.522c.482-1.305,1.491-2.363,3.26-1.731a2.171,2.171,0,0,1,1.422,3.129c-.353.986-.793,1.436-2.271,2.188a7.256,7.256,0,0,0-2.318,1.6l3.086,1.1-.664,1.225Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M239.026,43.581c-1.607,3-2.854,3.715-4.465,2.852s-1.667-2.352-.092-5.294c1.69-3.158,3.053-3.413,4.41-2.687,1.432.767,1.782,2.077.147,5.129m-3.11-1.734c-1.045,1.95-1.493,3.005-.718,3.42s1.372-.509,2.425-2.476c1.094-2.043,1.343-2.77.6-3.168-.7-.374-1.278.3-2.307,2.224",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M60.385,133.8v4.769c-6.887,0-8.675,3.443-15.165,3.443-11.655,0-18.675-9.47-18.675-20.993s7.484-20.992,18.344-20.992c4.636,0,8.543,1.655,11.125,4.767a5.5,5.5,0,0,0,1.788-3.377h1.656v14.57H57.67c-1.788-8.61-6.225-12.186-11.39-12.186-8.675,0-11.125,9.006-11.125,17.218,0,8.145,1.919,17.417,10.661,17.417,4.966,0,7.616-3.245,7.616-8.013,0-2.848-1.193-4.305-5.1-4.305v-1.921h16.49v1.921c-3.775,0-4.437,1.06-4.437,7.682",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M91.181,120.286a3.01,3.01,0,0,1-2.98-2.517c-.2-1.324-.6-2.251-2.053-2.251-1.722,0-4.238,2.98-4.238,9.073v7.019c0,6.291.794,7.417,4.9,7.417v1.855H69.592v-1.855c4.106,0,4.9-1.126,4.9-7.417v-9.536c0-6.291-.6-7.417-4.834-7.417V112.8l10.926-1.523a18.077,18.077,0,0,1,1.325,5.894c1.324-3.311,4.04-5.827,7.019-5.827,4.371,0,5.695,2.979,5.695,5.165a3.464,3.464,0,0,1-3.443,3.774",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M112.969,141.677c-8.808,0-13.973-6.622-13.973-15.3,0-9.072,6.489-15.032,13.444-15.032a10.7,10.7,0,0,1,11.191,10.927,10.425,10.425,0,0,1-.4,2.847H106.811v1.788c.131,6.358,1.853,11.059,8.211,11.059a11.362,11.362,0,0,0,7.814-3.708l1.59,2.317a14.768,14.768,0,0,1-11.457,5.1m-.132-27.086c-2.914,0-4.835,2.318-5.695,7.483h9.668a12.424,12.424,0,0,0,.132-1.788c0-3.641-1.258-5.695-4.105-5.695",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M152.9,141.412c-3.842,0-5.166-2.252-5.63-4.636-3.177,3.179-5.429,4.7-8.741,4.7-4.7,0-7.417-3.046-7.417-6.953,0-6.49,6.357-9.8,15.96-11.391v-2.052c0-5.232-.927-6.887-4.04-6.887a3.964,3.964,0,0,0-4.238,3.841,2.946,2.946,0,0,1-2.913,3.112,3.013,3.013,0,0,1-3.047-3.112c0-4.04,5.364-6.689,10.795-6.689,7.946,0,10.86,3.575,10.86,10.265v13.84c0,1.987.6,2.847,1.59,2.847a2.8,2.8,0,0,0,1.92-.926l.993,1.655a8.388,8.388,0,0,1-6.092,2.385m-5.828-15.762c-6.556,1.523-8.94,4.569-8.94,7.814,0,2.252,1.325,3.709,3.509,3.709,1.326,0,2.981-.6,5.431-2.98Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M174.494,141.544c-5.166,0-7.219-2.848-7.219-8.741V115.319H163.5V112.8c5.43-.861,7.218-4.039,7.748-9.006h3.443v8.477h5.828v3.045h-5.828V132.8c0,3.31.53,4.7,2.649,4.7,1.258,0,2.318-.663,3.642-2.119l1.193,1.92c-2.053,2.649-4.5,4.238-7.682,4.238",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M208.731,142.008c-5.3,0-8.145-2.384-10-3.245a7.014,7.014,0,0,0-1.921,2.914h-1.655V127.5h1.854c.794,5.5,5.165,10.927,11.589,10.927,4.437,0,6.821-2.45,6.821-5.96,0-3.312-3.775-5.5-7.351-7.351l-5.3-2.781a12.466,12.466,0,0,1-7.086-11.457,10.857,10.857,0,0,1,11.192-10.86,12.08,12.08,0,0,1,7.749,2.715,6.091,6.091,0,0,0,1.919-2.715h1.59v12.648h-1.854c-.729-5.033-3.907-9.139-9.272-9.139-3.046,0-5.3,1.987-5.3,4.967,0,3.046,2.451,4.636,7.683,7.417l4.967,2.649c4.7,2.516,6.953,6.556,6.953,10.795,0,7.284-4.834,12.648-12.583,12.648",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M238,141.544c-5.166,0-7.219-2.848-7.219-8.741V115.319h-3.774V112.8c5.43-.861,7.218-4.039,7.748-9.006H238.2v8.477h5.827v3.045H238.2V132.8c0,3.31.531,4.7,2.65,4.7,1.257,0,2.317-.663,3.641-2.119l1.193,1.92c-2.053,2.649-4.5,4.238-7.682,4.238",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M272.375,120.286a3.01,3.01,0,0,1-2.98-2.517c-.2-1.324-.6-2.251-2.053-2.251-1.722,0-4.238,2.98-4.238,9.073v7.019c0,6.291.794,7.417,4.9,7.417v1.855H250.786v-1.855c4.106,0,4.9-1.126,4.9-7.417v-9.536c0-6.291-.6-7.417-4.834-7.417V112.8l10.926-1.523a18.077,18.077,0,0,1,1.325,5.894c1.324-3.311,4.04-5.827,7.019-5.827,4.371,0,5.7,2.979,5.7,5.165a3.464,3.464,0,0,1-3.443,3.774",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M294.164,141.677c-8.808,0-13.973-6.622-13.973-15.3,0-9.072,6.489-15.032,13.444-15.032a10.7,10.7,0,0,1,11.191,10.927,10.425,10.425,0,0,1-.4,2.847H288.006v1.788c.131,6.358,1.853,11.059,8.211,11.059a11.362,11.362,0,0,0,7.814-3.708l1.59,2.317a14.768,14.768,0,0,1-11.457,5.1m-.132-27.086c-2.914,0-4.835,2.318-5.7,7.483h9.668a12.424,12.424,0,0,0,.132-1.788c0-3.641-1.257-5.695-4.1-5.695",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M325.753,141.677c-8.808,0-13.973-6.622-13.973-15.3,0-9.072,6.489-15.032,13.444-15.032a10.7,10.7,0,0,1,11.191,10.927,10.424,10.424,0,0,1-.4,2.847H319.6v1.788c.131,6.358,1.853,11.059,8.211,11.059a11.362,11.362,0,0,0,7.814-3.708l1.59,2.317a14.768,14.768,0,0,1-11.457,5.1m-.132-27.086c-2.914,0-4.835,2.318-5.7,7.483h9.668a12.423,12.423,0,0,0,.132-1.788c0-3.641-1.257-5.695-4.105-5.695",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M354.033,141.544c-5.166,0-7.219-2.848-7.219-8.741V115.319H343.04V112.8c5.43-.861,7.218-4.039,7.748-9.006h3.443v8.477h5.828v3.045h-5.828V132.8c0,3.31.53,4.7,2.649,4.7,1.258,0,2.318-.663,3.642-2.119l1.193,1.92c-2.053,2.649-4.5,4.238-7.682,4.238",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M289.238,175.22a108.092,108.092,0,0,1-188.315,0H98.049l.345.62a110.612,110.612,0,0,0,193.374,0l.345-.62Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M100.934,69.068a108.091,108.091,0,0,1,188.292,0H292.1l-.338-.608a110.611,110.611,0,0,0-193.365,0l-.339.608Z",
    transform: "translate(648.419 -302)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsLogo);
export default __webpack_public_path__ + "static/media/gs_logo.32012b6be6b783fb05cd39b507a03e31.svg";
export { ForwardRef as ReactComponent };